// extracted by mini-css-extract-plugin
export default {"terms-card":"styles__terms-card--uQD10","terms":"styles__terms--0D0Ut","divider":"styles__divider--SkiBF"};